module.exports = __webpack_public_path__ + "static/media/mansabank.682feb02.png";